import { useTimezone } from '@app/core/hooks';
import { forceTz } from '@mi-front/core';
import { DateField, TimeField } from '@mi-front/ui';
import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { GipReportValues } from '../types';

export const FromField = () => {
  const { $t } = useIntl();
  const {
    values: { from },
    setFieldValue,
  } = useFormikContext<GipReportValues>();
  const tz = useTimezone();

  return (
    <Grid container>
      <Grid item xs={12} md={7}>
        <DateField
          name="from"
          label={$t({
            id: 'audit.gipReport.form.startDate',
            defaultMessage: 'Fecha de inicio',
          })}
          max={moment(new Date()).format('YYYY-MM-DD')}
          isOutsideRange={(date) => moment(date) > moment()}
          onChange={(value) => {
            const time = moment(from).tz(tz).format('HH:mm:ss');
            const date = forceTz(`${value} ${time}` as any, tz);

            setFieldValue('from', moment(date).toISOString());
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TimeField
          name="from_time"
          label={$t({
            id: 'audit.gipReport.form.startTime',
            defaultMessage: 'Hora de inicio',
          })}
          value={moment(from).format('HH:mm')}
          onChange={(event) => {
            const [hour, minutes] = event.currentTarget.value.split(':');
            const value = moment(from).hour(Number(hour)).minutes(Number(minutes));

            setFieldValue('from', value.toISOString());
          }}
        />
      </Grid>
    </Grid>
  );
};
